import React from "react";
import "./Avatar.css";

interface AvatarProps {
  src?: string;
  alt?: string;
  size?: number | string;
  className?: string;
}

const Avatar: React.FC<AvatarProps> = ({
  src,
  alt = "Imagem",
  size = 40,
  className = "",
}) => {
  const initials = (alt || "MC")
    .trim()
    .split(/\s+/)
    .map((part) => part[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

  const dimension = typeof size === "number" ? `${size}px` : size;

  return (
    <div
      className={`avatar-circle ${className}`.trim()}
      style={{ width: dimension, height: dimension }}
    >
      {src ? (
        <img src={src} alt={alt} className="avatar" />
      ) : (
        <span className="avatar-fallback">{initials}</span>
      )}
    </div>
  );
};

export default Avatar;
